import { Routes } from '@angular/router';
import { SlideMenuEventComponent } from './features/vibration-events/components/slide-menu-event/slide-menu-event.component';
import { SeismographDevicesComponent } from './features/seismograph-devices/components/seismograph-devices-modal/seismograph-devices-modal.component';
import { MapComponent } from './features/map/components/map-component/map.component';
import { VibrationDetailpage } from './shared/pages/vibration-detail/vibration-detail.page';
import { DeviceDetailComponent } from './features/seismograph-devices/components/device-detail/device-detail.component';
import { SettingComponent } from '@features/settings/setting/setting.component';
import { SiteDetailsComponent } from '@features/settings/sites-area/components/site-details/site-details.component';
import { MonitoringComponent } from '@features/monitoring/monitoring.component';
import { ControlPointPageComponent } from './features/control-points/pages/control-point-page.component';
import { EventPageComponent } from './features/vibration-events/pages/event-page.component';
import { homeRedirectGuard } from './core/guards/home-redirect.guard';
import { TimelineComponent } from '@features/timeline/timeline.component';

export const routes: Routes = [
    { path: '', component: MapComponent, canActivate: [homeRedirectGuard] },
    { path: 'home', component: MapComponent },
    { path: 'vibration-detail', component: VibrationDetailpage },
    { path: 'events', component: SlideMenuEventComponent },
    { path: 'devices', component: SeismographDevicesComponent },
    { path: 'device-detail', component: DeviceDetailComponent },
    { path: 'monitoring', component: MonitoringComponent },
    { path: 'timeline', component: TimelineComponent },
    { path: 'settings', component: SettingComponent },
    { path: 'settings/site-details', component: SiteDetailsComponent },
    { path: 'control-point', component: ControlPointPageComponent },
    { path: 'event', component: EventPageComponent },
];
